import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { Field, reduxForm } from 'redux-form'
import Grid from 'material-ui/Grid'
import URLSearchParams from 'url-search-params'

import {
  confirm,
  send as sendInstructions,
  getConfirmationUri,
  getReferralUri
} from 'modules/users/confirmations'
import ValidationErrors from '../validation_errors'
import Group from '../group'
import Submit from '../submit'
import errorsSelector from 'selectors/errors'

const ConfirmationForm = ({ submitting, handleSubmit, errors }) => (
  <form onSubmit={handleSubmit} className="short-form">
    <br />
    <ValidationErrors errors={errors} />
    <Grid container direction="column">
      <Grid item>
        <Field
          name="email"
          type="email"
          component={Group}
          label={I18n.t('users.common.email')}
          required
        />
      </Grid>
      <Grid item>
        <br />
        <Submit value={I18n.t('users.confirmation.submit')} disabled={submitting} />
      </Grid>
    </Grid>
  </form>
)

class ConfirmationFormContainer extends Component {
  componentDidMount() {
    const { confirm } = this.props
    const confirmation_token = new URLSearchParams(window.location.search).get('confirmation_token')
    confirmation_token && confirm({ confirmation_token })
  }

  render() {
    return <ConfirmationForm {...this.props} />
  }
}

const mapStateToProps = state => ({
  errors: errorsSelector('users.confirmations', 'validation_error')(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({ confirm, sendInstructions }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'users_confirmation',
    onSubmit: (props, dispatch, { sendInstructions, push, toastr }) =>
      sendInstructions({
        ...props,
        confirmation_uri: getConfirmationUri(window.location),
        referral_uri: getReferralUri(window.location)
      })
  })(ConfirmationFormContainer)
)



// WEBPACK FOOTER //
// ./src/containers/pages/users/confirmation/form.js